import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import central from '../api/Central';
import Logo from '../components/Logo.js';
import Navegacao from '../components/Navegacao.js';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kit: {}
    };

  }

  logout() {
    central.logout();
  }
  componentDidMount() {
    central.fetchKit(() => {
      this.setState({ kit: central.kit });
    })
  }
  render() {
    return (
      <div>
        <Navegacao />
        <header id="home" className="header">
          <section className="container">
            <Logo width="400" />
            {this.props.kit.avisoGeral && <div className="avisogeral" dangerouslySetInnerHTML={{ __html: this.props.kit.avisoGeral }} />}
            <h1 className="title">Atendimento Eletrônico</h1>
            {this.props.whoami.autenticado &&
              <React.Fragment>
                <div className="pessoalogada"><span className="fa fa-user"> </span> {this.props.whoami.nome} ({this.props.whoami.docFazenda})</div>
              </React.Fragment>
            }
          </section>
        </header>

        <div className="container">
          {this.state.kit.permiteBoleto && <React.Fragment>
            <div className="problema">Preciso pagar uma conta</div>
            <div className="solucao">
              <Link to="boletos"><span className="fa fa-barcode"></span> 2ª via de boleto</Link>
            </div>
          </React.Fragment>}
          <div className="problema">Estou com problemas no acesso</div>
          {this.state.kit.permiteReligar && <React.Fragment>
            <div className="solucao">
              <Link to="religar"><span className="fa fa-plug"></span> Religar serviço bloqueado</Link>
            </div>
          </React.Fragment>}
          {this.state.kit.permiteChamado && <React.Fragment>
            <div className="solucao">
              <Link to="chamados"><span className="fa fa-wrench"></span> Abrir ou acompanhar chamados</Link>
            </div>
          </React.Fragment>}
          {this.state.kit.permiteLogAcessos && <React.Fragment>
            <div className="problema">Quero acompanhar meu consumo</div>
            <div className="solucao">
              <Link to="acessos"><span className="fa fa-table"></span> Consultar histórico de acessos</Link>
            </div>
          </React.Fragment>}
          {this.state.kit.permiteNotasFiscais && <React.Fragment>
            <div className="problema">Notas fiscais</div>
            <div className="solucao">
              <Link to="notas"><span className="fa fa-file-pdf"></span> Exibir notas fiscais</Link>
            </div>
          </React.Fragment>}
          <div className="problema">Links úteis</div>
          <div className="solucao">
            <a href={this.props.kit.urlTesteBanda != null ? this.props.kit.urlTesteBanda : "https://www.speedtest.net/"} target="_blank" rel="noopener noreferrer"><span className="fa fa-link"></span> Testar minha velocidade</a>
          </div>
          {this.props.whoami.autenticado &&
            <React.Fragment>
              <div className="problema">Terminar atendimento</div>
              <div className="solucao">
                <a href="#" onClick={this.logout.bind(this)}><span className="fa fa-sign-out-alt"></span> Sair</a>
              </div>
            </React.Fragment>
          }
        </div>
      </div >
    );
  }
}

export default Home;